function DashboardIcon({ white = false }: { white?: boolean }) {
	return (
		<svg
			width="24"
			height="24"
			viewBox="0 0 24 24"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<path
				d="M8.24805 21.3749H2.81055C1.77503 21.3749 0.935547 20.5354 0.935547 19.4999V4.49988C0.935547 3.46436 1.77503 2.62488 2.81055 2.62488H8.24805C9.28356 2.62488 10.123 3.46436 10.123 4.49988V19.4999C10.123 20.5354 9.28356 21.3749 8.24805 21.3749Z"
				stroke={white ? "white" : "#4D5561"}
				strokeWidth="1.5"
				strokeMiterlimit="10"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M21.1855 10.1249H15.748C14.7125 10.1249 13.873 9.28539 13.873 8.24988V4.49988C13.873 3.46436 14.7125 2.62488 15.748 2.62488H21.1855C22.2211 2.62488 23.0605 3.46436 23.0605 4.49988V8.24988C23.0605 9.28539 22.2211 10.1249 21.1855 10.1249Z"
				stroke={white ? "white" : "#4D5561"}
				strokeWidth="1.5"
				strokeMiterlimit="10"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M21.1855 21.3749H15.748C14.7125 21.3749 13.873 20.5354 13.873 19.4999V15.7499C13.873 14.7144 14.7125 13.8749 15.748 13.8749H21.1855C22.2211 13.8749 23.0605 14.7144 23.0605 15.7499V19.4999C23.0605 20.5354 22.2211 21.3749 21.1855 21.3749Z"
				stroke={white ? "white" : "#4D5561"}
				strokeWidth="1.5"
				strokeMiterlimit="10"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</svg>
	);
}

export default DashboardIcon;
